export const SEARCH_PARAMS = 'SEARCH_PARAMS';
export const SEARCH_TIMESTAMP = 'SEARCH_TIMESTAMP';
export const SEARCH_RESULT = 'SEARCH_RESULT';
export const SEARCH_TOTAL_NUMBER = 'SEARCH_TOTAL_NUMBER';
export const REGISTER_CLEAR_FILTER = 'REGISTER_CLEAR_FILTER';
export const INITIAL_FILTER_STATUS = 'INITIAL_FILTER_STATUS';
export const LOADING = 'LOADING';
